import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { WorkspacePage } from '~/features/business/business-page';

/**
 * Workspace details (web-redesign-03 phase 7; Decided 9; ui-quick-fixes U5):
 * the tabs Details, What OS knows and How it was set up under one head. The
 * tab is in the address, so a link can open any one of them, and in What OS
 * knows a file (an imported entry's Source links to the file it came from).
 */
const search = z.object({
  section: z.enum(['details', 'knows', 'setup']).optional(),
  /** What OS knows: its Facts or its Files half, and a file to open there (setup-from-files.md, Decided 20). */
  half: z.enum(['facts', 'files']).optional(),
  file: z.string().uuid().optional(),
});

export type WorkspaceSearch = z.infer<typeof search>;

export const Route = createFileRoute('/_app/business/')({ validateSearch: search, component: WorkspacePage });
